var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',_vm._b({staticClass:"text-body-1 mb-3"},'h3',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }